import {
  ApiRemoveAllDiscountCodesFromCartsRequestedAction,
  apiRemoveAllDiscountCodesFromCartsFailed,
  apiRemoveAllDiscountCodesFromCartsSucceeded
} from '@spa/lib/store/api/cart/removeAllDiscountCodesFromCartsApi';
import { call, put } from 'typed-redux-saga';
import removeAllDiscountCodesFromCartsAction, {
  RemoveAllDiscountCodesFromCartsActionInput,
  RemoveAllDiscountCodesFromCartsActionResult
} from '@spa/lib/actions/cart/removeAllDiscountCodesFromCartsAction';

function* removeAllDiscountCodesFromCartsSaga({
  payload: { customOrderType, parentActionId, actionId: requestedActionId }
}: ApiRemoveAllDiscountCodesFromCartsRequestedAction): Generator {
  try {
    const input: RemoveAllDiscountCodesFromCartsActionInput = { customOrderType };
    const { cartId, result }: RemoveAllDiscountCodesFromCartsActionResult = yield* call(
      removeAllDiscountCodesFromCartsAction,
      'removeAllDiscountCodesFromCartsAction',
      input
    );

    yield* put(
      apiRemoveAllDiscountCodesFromCartsSucceeded({
        requestedActionId,
        parentActionId,
        result,
        cartId
      })
    );
  } catch {
    yield* put(
      apiRemoveAllDiscountCodesFromCartsFailed({
        requestedActionId,
        parentActionId
      })
    );
  }
}

export default removeAllDiscountCodesFromCartsSaga;
